window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.chat = window.locales.am.chat || {};window.locales.am.chat.chat = window.locales.am.chat.chat || {};window.locales.am.chat.chat = {...window.locales.am.chat.chat, ...{
    "new_topic": "አዲስ ርዕስ",
    "submit_message": "መልእክት አስገባ",
    "talk_about_next": "ቀጥሎ ስለምን መነጋገር ይፈልጋሉ?",
    "hi_user": "ሰላም፣ {userName}! እንኳን ደህና መጣህ. ዛሬ እንዴት መርዳት እችላለሁ?",
    "learn_more": "ተጨማሪ እወቅ:",
    "rate_thumbs_up": "ይህንን መልስ በአውራ ጣት ወደ ላይ ደረጃ ይስጡት።",
    "rate_thumbs_down": "ይህንን መልስ በአውራ ጣት ወደ ታች ደረጃ ይስጡት።",
    "ai_welcome_message_stay_tuned": "ለማሻሻያዎች እና አዳዲስ መስተጋብር መንገዶችን ይጠብቁ!",
    "error": "ውይ። የሆነ ስህተት ተከስቷል. እባክዎ ዳግም ይሞክሩ.",
    "exam_in_progress_message": "ሰላም፣ {name}! {examTitle}ን እንደጨረሱ ቻታችን እንደገና ይገኛል። መልካም እድል!",
    "cancel_response": "ሰርዝ",
    "locked_unavailable": "{botName} በአሁኑ ጊዜ አይገኝም፣ ለተፈጠረው ችግር እናዝናለን።",
    "bot_can_make_mistakes": "{botName} ስህተት ሊሠራ ይችላል። ጠቃሚ መረጃን ለማጣራት ያስቡበት.",
    "toggle_audio_or_text": "ኦዲዮ ወይም ጽሑፍ ቀይር",
    "you_have_used_your_voice_time": "በዚህ ሳምንት የእርስዎን {allowedMinutes} ደቂቃዎች ተጠቅመዋል። አዲስ ደቂቃዎች በ {refreshDayOfWeek} በ {refreshHour} (በአካባቢዎ ሰዓት) ይከፈታሉ።",
    "searching_support_articles": "የድጋፍ ጽሑፎችን በመፈለግ ላይ…",
    "searching_course_content": "የኮርስ ይዘትን በመፈለግ ላይ…",
    "searching_project_documents": "የፕሮጀክት ሰነዶችን በመፈለግ ላይ…",
    "reading_schedule": "መርሐግብርን በማንበብ ላይ…",
    "checking_grades": "ደረጃዎችን በመፈተሽ ላይ…",
    "searching_multiple_sources": "ብዙ ምንጮችን በመፈለግ ላይ…",
    "thinking": "በማሰብ ላይ…",
    "checking_payment_info": "የክፍያ መረጃን በመፈተሽ ላይ…",
    "checking_student_info": "የተማሪ መረጃን በመፈተሽ ላይ…"
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.chat = window.locales.ar.chat || {};window.locales.ar.chat.chat = window.locales.ar.chat.chat || {};window.locales.ar.chat.chat = {...window.locales.ar.chat.chat, ...{
    "new_topic": "موضوع جديد",
    "submit_message": "تقديم رسالة",
    "talk_about_next": "عن ماذا تريد أن نتحدث بعد ذلك؟",
    "hi_user": "مرحبًا {userName}! مرحبًا بعودتك. كيف يمكنني المساعدة اليوم؟",
    "learn_more": "يتعلم أكثر:",
    "rate_thumbs_up": "قيم هذه الإجابة بإبهام لأعلى.",
    "rate_thumbs_down": "قيم هذه الإجابة بإعجاب.",
    "ai_welcome_message_stay_tuned": "ترقبوا الترقيات والطرق الجديدة للتفاعل!",
    "error": "أُووبس. هناك خطأ ما. حاول مرة اخرى.",
    "exam_in_progress_message": "مرحبًا {name}! ستكون محادثتنا متاحة مرة أخرى بمجرد إكمال {examTitle}. حظا سعيدا!",
    "cancel_response": "يلغي",
    "locked_unavailable": "{botName} غير متاح حاليًا، ونحن نأسف للإزعاج.",
    "bot_can_make_mistakes": "قد يرتكب {botName} أخطاءً. فكر في التحقق من المعلومات المهمة.",
    "toggle_audio_or_text": "تبديل الصوت أو النص",
    "you_have_used_your_voice_time": "لقد استخدمتَ {allowedMinutes} دقيقة من وقتك الصوتي هذا الأسبوع. ستُتاح الدقائق الجديدة في {refreshDayOfWeek} الساعة {refreshHour} (بتوقيتك المحلي).",
    "searching_support_articles": "جارٍ البحث في مقالات الدعم…",
    "searching_course_content": "جارٍ البحث في محتوى الدورة…",
    "searching_project_documents": "جارٍ البحث في مستندات المشروع…",
    "reading_schedule": "جارٍ قراءة الجدول…",
    "checking_grades": "جارٍ التحقق من الدرجات…",
    "searching_multiple_sources": "جارٍ البحث في مصادر متعددة…",
    "thinking": "جارٍ التفكير…",
    "checking_payment_info": "جارٍ التحقق من معلومات الدفع…",
    "checking_student_info": "جارٍ التحقق من معلومات الطالب…"
}
};window.locales.en = window.locales.en || {};window.locales.en.chat = window.locales.en.chat || {};window.locales.en.chat.chat = window.locales.en.chat.chat || {};window.locales.en.chat.chat = {...window.locales.en.chat.chat, ...{
    "new_topic": "New Topic",
    "submit_message": "Submit Message",
    "talk_about_next": "What would you like to talk about next?",
    "cancel_response": "Cancel",
    "ai_welcome_message_stay_tuned": "Stay tuned for upgrades and new ways to interact!",
    "learn_more": "Learn More:",
    "rate_thumbs_up": "Rate this answer with thumbs up.",
    "rate_thumbs_down": "Rate this answer with thumbs down.",
    "error": "Oops. Something went wrong. Please try again.",
    "exam_in_progress_message": "Hi, {name}! Our chat will be available again once you've completed the {examTitle}. Best of luck!",
    "locked_unavailable": "{botName} is currently unavailable, we are sorry for the inconvenience.",
    "bot_can_make_mistakes": "{botName} can make mistakes. Consider checking important information.",
    "toggle_audio_or_text": "Toggle audio or text",
    "you_have_used_your_voice_time": "You've used your {allowedMinutes} minutes of voice time this week. New minutes unlock on {refreshDayOfWeek} at {refreshHour} (your local time).",
    "searching_support_articles": "Searching support articles…",
    "searching_course_content": "Searching course content…",
    "searching_project_documents": "Searching project documents…",
    "reading_schedule": "Reading schedule…",
    "checking_grades": "Checking grades…",
    "searching_multiple_sources": "Searching multiple sources…",
    "thinking": "Thinking…",
    "checking_payment_info": "Checking payment info…",
    "checking_student_info": "Checking student info…"
}
};window.locales.es = window.locales.es || {};window.locales.es.chat = window.locales.es.chat || {};window.locales.es.chat.chat = window.locales.es.chat.chat || {};window.locales.es.chat.chat = {...window.locales.es.chat.chat, ...{
    "new_topic": "Nuevo tema",
    "submit_message": "Enviar mensaje",
    "talk_about_next": "¿De qué te gustaría hablar a continuación?",
    "hi_user": "¡Hola, {userName}! Bienvenido de nuevo. ¿Cómo puedo ayudar hoy?",
    "learn_more": "Aprende más:",
    "rate_thumbs_up": "Califica esta respuesta con pulgares arriba.",
    "rate_thumbs_down": "Califica esta respuesta con los pulgares hacia abajo.",
    "ai_welcome_message_stay_tuned": "¡Estén atentos a las actualizaciones y nuevas formas de interactuar!",
    "error": "Ups. Algo salió mal. Inténtalo de nuevo.",
    "exam_in_progress_message": "Hola, {name}! Nuestro chat volverá a estar disponible una vez que haya completado el {examTitle}. ¡Toda la suerte!",
    "cancel_response": "Cancelar",
    "locked_unavailable": "{botName} no está disponible actualmente, lamentamos las molestias.",
    "bot_can_make_mistakes": "{botName} puede cometer errores. Considere verificar la información importante.",
    "toggle_audio_or_text": "Alternar audio o texto",
    "you_have_used_your_voice_time": "Has usado tus {allowedMinutes} minutos de voz esta semana. Los minutos nuevos se desbloquean el {refreshDayOfWeek} a las {refreshHour} (tu hora local).",
    "searching_support_articles": "Buscando artículos de soporte…",
    "searching_course_content": "Buscando contenido del curso…",
    "searching_project_documents": "Buscando documentos del proyecto…",
    "reading_schedule": "Leyendo el horario…",
    "checking_grades": "Verificando calificaciones…",
    "searching_multiple_sources": "Buscando en múltiples fuentes…",
    "thinking": "Pensando…",
    "checking_payment_info": "Verificando información de pago…",
    "checking_student_info": "Verificando información del estudiante…"
}
};window.locales.it = window.locales.it || {};window.locales.it.chat = window.locales.it.chat || {};window.locales.it.chat.chat = window.locales.it.chat.chat || {};window.locales.it.chat.chat = {...window.locales.it.chat.chat, ...{
    "new_topic": "Nuovo argomento",
    "submit_message": "Invia messaggio",
    "talk_about_next": "Di cosa vorresti parlare dopo?",
    "hi_user": "Ciao, {userName}! Bentornato. Come posso aiutare oggi?",
    "learn_more": "Saperne di più:",
    "rate_thumbs_up": "Vota questa risposta con pollice in su.",
    "rate_thumbs_down": "Valuta questa risposta con il pollice in giù.",
    "ai_welcome_message_stay_tuned": "Resta sintonizzato per aggiornamenti e nuovi modi di interagire!",
    "error": "Ops. Qualcosa è andato storto. Per favore riprova.",
    "exam_in_progress_message": "Ciao, {name}! La nostra chat sarà di nuovo disponibile una volta completato il {examTitle}. Buona fortuna!",
    "cancel_response": "Annulla",
    "locked_unavailable": "{botName} non è al momento disponibile, ci scusiamo per l'inconveniente.",
    "bot_can_make_mistakes": "{botName} può commettere errori. Valuta di controllare le informazioni importanti.",
    "toggle_audio_or_text": "Attiva/disattiva audio o testo",
    "you_have_used_your_voice_time": "Hai utilizzato {allowedMinutes} minuti di conversazione questa settimana. I nuovi minuti saranno disponibili il {refreshDayOfWeek} alle ore {refreshHour} (ora locale).",
    "searching_support_articles": "Ricerca degli articoli di supporto…",
    "searching_course_content": "Ricerca dei contenuti del corso…",
    "searching_project_documents": "Ricerca dei documenti del progetto…",
    "reading_schedule": "Lettura del programma…",
    "checking_grades": "Verifica dei voti…",
    "searching_multiple_sources": "Ricerca in più fonti…",
    "thinking": "Sto pensando…",
    "checking_payment_info": "Verifica delle informazioni di pagamento…",
    "checking_student_info": "Verifica delle informazioni dello studente…"
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.chat = window.locales.zh.chat || {};window.locales.zh.chat.chat = window.locales.zh.chat.chat || {};window.locales.zh.chat.chat = {...window.locales.zh.chat.chat, ...{
    "new_topic": "新话题",
    "submit_message": "提交消息",
    "talk_about_next": "接下来你想谈什么？",
    "hi_user": "嗨，{userName}！欢迎回来。今天我能提供什么帮助？",
    "learn_more": "了解更多：",
    "rate_thumbs_up": "竖起大拇指评价这个答案。",
    "rate_thumbs_down": "用大拇指向下评价这个答案。",
    "ai_welcome_message_stay_tuned": "请继续关注升级和新的互动方式！",
    "error": "哎呀。出了些问题。请再试一次。",
    "exam_in_progress_message": "嗨，{name}！完成 {examTitle} 后，我们的聊天将再次可用。祝你好运！",
    "cancel_response": "取消",
    "locked_unavailable": "{botName}目前不可用，我们对此造成的不便深感抱歉。",
    "bot_can_make_mistakes": "{botName}可能会出错。请考虑检查重要信息。",
    "toggle_audio_or_text": "切换音频或文本",
    "you_have_used_your_voice_time": "您本周已使用{allowedMinutes}分钟的语音时长。新的通话时长将于{refreshDayOfWeek} {refreshHour} （您的当地时间）解锁。",
    "searching_support_articles": "正在搜索支持文章…",
    "searching_course_content": "正在搜索课程内容…",
    "searching_project_documents": "正在搜索项目文档…",
    "reading_schedule": "正在读取课程表…",
    "checking_grades": "正在查看成绩…",
    "searching_multiple_sources": "正在搜索多个来源…",
    "thinking": "正在思考…",
    "checking_payment_info": "正在查看付款信息…",
    "checking_student_info": "正在查看学生信息…"
}
};